import React from 'react';
import { Link } from 'react-router-dom';

const ServicesOneHiringAreaObstetricGyanecology = () => {
    return (
        <>
            <section className="hiring-area pt-120 pb-120">
                <div className="container">
                    <div className="row no-gutters hire-bg-2">
                        <div className="col-xl-6 col-lg-6">
                            <div className="hire-img">
                                <img className="img" src="img/doctor/Dr. Tulika Singh.jpg" alt="" />
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-6">
                            <div className="hire-text">
                                <h1>Dr. TULIKA SINGH</h1>
                                <p>
                                    M.B.B.S., FGO, PGDS, Obstetrician & Gynaecologist Ex. Medical Office LBS Hospital, New Delhi
                                    <br />
                                    10 years of experience in high risk pregnancies Infertility, normal delivery & several caesarean section.
                                </p>
                                <Link to="/contact"
                                    className="primary_btn btn-icon btn-icon-green ml-0"><span>+</span>Contact us</Link>
                            </div>
                        </div>
                    </div>
                    <div className="row no-gutters hire-bg">
                        <div className="col-xl-6 col-lg-6">
                            <div className="hire-text">
                                <h1>Dr. SARIKA SINGH</h1>
                                <p>
                                    M.B.B.S.
                                </p>
                                <Link to="/contact"
                                    className="primary_btn btn-icon ml-0"><span>+</span>Contact Us</Link>
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-6">
                            <div className="hire-img">
                                <img className="img" src="img/doctor/Dr. Sarika Singh.jpg" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default ServicesOneHiringAreaObstetricGyanecology;